export enum ChecklistTaskStatus {
  Completed = "completed",
  InProgress = "in-progress",
  Cancelled = "cancelled",
}

export enum ChecklistVisibility {
  Public = "public",
  Private = "private",
}

export enum ChecklistTaskChangeDirection {
  Up = "up",
  Down = "down",
}
